import { DatePipe } from '@angular/common';
import { Component, computed, inject, Input, input, signal } from '@angular/core';
import { PortraitService } from '../../../services/portraits/portrait.service';
import { MessengerService } from '../../../services/messenger/messenger.service';
import { ChatService } from '../../../services/chat/chat.service';

@Component({
  selector: 'app-message',
  imports: [DatePipe],
  templateUrl: './message.html',
  styleUrl: './message.scss',
})
export class Message {
  private portraitService = inject(PortraitService);
  private messengerService = inject(MessengerService);
  private chatService = inject(ChatService);
  private portraits = this.portraitService.portraits;

  showModerator = input<boolean>(false);

  isModerator = computed(() => {
    if (!this.showModerator()) return false;

    const arena = this.chatService.arena();
    if (!arena || arena.parentGuid == null) return false;

    const msg = this._message();
    if (!msg || !msg.fromUser) return false;

    const sender = msg.fromUser;
    const senderId = sender.id || sender.guid || sender.userId;

    const isOwner =
      (senderId && arena.ownerId === senderId) ||
      (sender.userName && arena.ownerId === sender.userName);

    if (isOwner) return true;

    const roomUser = this.chatService.users().find(u => u.userName === sender.userName || u.id === senderId || u.guid === senderId);
    if (roomUser && (roomUser.role === 'admin' || roomUser.role === 'moderator')) {
      return true;
    }

    return false;
  });

  isParentLobbyOwner = computed(() => {
    if (!this.showModerator()) return false;

    const arena = this.chatService.arena();
    if (!arena) return false;

    const msg = this._message();
    if (!msg || !msg.fromUser) return false;

    const sender = msg.fromUser;
    const senderId = sender.id || sender.guid || sender.userId;
    const parentOwnerId = arena.parentGuid == null ? arena.ownerId : arena.parentOwnerId;

    if (!parentOwnerId) return false;

    return (senderId && senderId === parentOwnerId) || (sender.userName && sender.userName === parentOwnerId);
  });

  getUserPortrait = (id: any) => computed(() => {
    if (this.portraits().length > 0) {
      let portrait = this.portraits().filter(e => { return e.id == id; })[0];
      if (portrait) {
        return portrait.fileName;
      }
      else
        return "bagfacepak/2.jpg";
    }
    else
      return "bagfacepak/2.jpg";
  });

  private _message = signal<any>(null);

  @Input()
  public set message(val: any) {
    this._message.set(val);
  }
  public get message(): any {
    return this._message();
  }

  public isImage = computed(() => {
    const msg = this._message();
    if (!msg || !msg.text) return false;
    const text = msg.text.toLowerCase();
    return text.startsWith('http') && (
      text.endsWith('.gif') ||
      text.endsWith('.png') ||
      text.endsWith('.jpg') ||
      text.endsWith('.jpeg') ||
      text.endsWith('.webp') ||
      text.includes('giphy.com') // GIPHY urls often don't end with .gif in their display form
    );
  });

  public hasAttachment = computed(() => {
    const msg = this._message();
    return msg && msg.attachment;
  });



  public uniqueId = 'msg-' + Math.random().toString(36).substring(2, 9);

  public get lightboxSrc(): string {
    const msg = this._message();
    if (!msg) return '';
    if (this.hasAttachment()) {
      return msg.attachment.url;
    }
    if (this.isImage()) {
      return msg.text;
    }
    return '';
  }

  public openLink(url: string) {
    this.messengerService.externalUrl.set(url);
  }

  onUserDblClick() {
    const fromUser = this.message.fromUser;
    if (!fromUser) return;

    const username = fromUser.userName;
    const fullUser = this.chatService.users().find(u => u.userName === username) || fromUser;

    this.chatService.selectedUserForModal.set(fullUser);

    const modalEl = document.getElementById('userProfileModal');
    if (modalEl) {
      const modal = new (window as any).bootstrap.Modal(modalEl);
      modal.show();
    }
  }
}
